import {Model} from "@vuex-orm/core";

export default class PackageInternalTagPackage extends Model {
    static entity = 'packageInternalTagPackage'

    static primaryKey = ['package_id', 'package_internal_tag_id']

    static fields () {
        return {
            package_id: this.number(null).nullable(),
            package_internal_tag_id: this.number(null).nullable(),
        }
    }
}
